module.exports = __webpack_public_path__ + "static/media/js.b012529a.svg";